import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from "../common-utilities.service";
import * as $ from 'jquery';
import { constants } from '../constants';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ChangeChipService } from "./change-chip.service";
import { CodificadorJWT } from 'src/util/codificador/CodificadorJWT';
import { PrivacyService } from '../privacy/privacy.service';
declare var $: any;

@Component({
  selector: 'app-change-chip',
  templateUrl: './change-chip.component.html',
  styleUrls: ['./change-chip.component.scss']
})
export class ChangeChipComponent implements OnInit {
  imei = constants.IMEI_TITLE;
  phoneBrand: any;
  phoneImei: any;
  selectedLine = false;

  isFileLoadDocCopy = false;
  isFileLoadPortForm = false;
  isFileLoadDocCopyFront = false;
  isFileLoadDocCopyReverse = false;

  changeChipForm: FormGroup;
  numericPattern = "";
  alphanumericPattern = "";
  emailPattern = "";
  isBtnDisabled = false;

  //ventana modal
  isShowModal = false;
  isChangeChipBtn = false;
  modalTitle: any;
  modalContent: any;
  isModalReload = false;
  buttonTittle = "";
  isShowSecondBtn = true;

  //dato quemado que viene de WS
  lineaSolicitada = "";
  listLines = [];
  listLineData: any;
  isLoading = false;
  isICCValid = false;
  isLoadingICC = false;

  //data objects
  fileLoadPortFormData = null;
  fileLoadDocCopyData = null;
  fileLoadDocCopyFrontData = null;
  fileLoadDocCopyReverseData = null;

  valueAes = ""

  //file input
  ACCEPT_FILES = constants.ACCEPT_FILES;
  constructor(public LANG: CommonUtilitiesService, private formbuilder: FormBuilder, private _router: Router, private changeChipService: ChangeChipService, private privacyService: PrivacyService) { }

  ngOnInit() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    this.setTooltips();
    //validaciones de formulario
    this.numericPattern = constants.REGEX_NUMERIC_PATTERN;
    this.alphanumericPattern = constants.REGEX_ALPHANUMERIC_PATTERN;
    this.emailPattern = constants.REGEX_EMAIL_PATTERN;
    this.changeChipForm = this.formbuilder.group({
      inputLines: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      checkAuto: ['', [Validators.required]],
      checkTerms: ['', [Validators.required]],
      inputFileDocCopy: ['', []],
      inputFileDocCopyFront: ['', []],
      inputFileDocCopyReverse: ['', []],
      inputICC: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
    });

    //obtiene las lineas de sesion
    let userData = JSON.parse(localStorage.getItem("userData"));
    for (var k in userData.associatedCellPhones) {
      this.listLines.push({ "id": userData.associatedCellPhones[k].id, "linea": userData.associatedCellPhones[k].id });
    }
  }

  /**
    * Description: Método que setea la información de los tooltips de la página
    * Autor: Steven Sterling
    * @param N/A
    * @return N/A
    */
  setTooltips() {
    let iccTooltipText = this.LANG.getLangText('PORTABILITY_TOOLTIP_ICC');
    $('#tooltipICC').popover({
      template: `
      <div class="popover bg-gris-claro2 rounded texto-centrado"  role="tooltip">
        <div class="arrow arrow-gris"></div><div class="popover-body"></div>
      </div>`,
      html: true,
      content: '<div>' + iccTooltipText + '<br><img src="./assets/chip.png"></div>'
    });
  }

  /**
  * Description: Método que valida si se ha subido un archivo y lo marca como OK
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  setFileOkFlag($event) {
    let id = $event.target.id;
    let filename = $('#' + id).val();

    /**
     * @AddBy Julian Ciro
     * Se añade validación que verifica la extensión del archivo
     */
    const isFileValid = constants.EXTENSION_FILE_AVAILABLE.includes(filename.substring(filename.lastIndexOf('.')).toUpperCase());
    if(!isFileValid){
      this.modalTitle = this.LANG.getLangText('EXTENSION_FILE_INVALID_TITTLE');
      this.modalContent = this.LANG.getLangText('EXTENSION_FILE_INVALID');
      this.isShowModal = true;
      $('#' + id).val(''); //ID del input file hiddden
      $('#' + id + 'Face').val(''); //ID del input que muestra la ruta del archivo seleccionado
      return;
    }

    $('#' + id + "Face").val(filename);
    //carga el archivo en base64
    this.getBase64($event.target, id);

    if (id == 'inputFilePortForm') {
      this.isFileLoadPortForm = true;
    }
    if (id == 'inputFileDocCopy') {
      this.isFileLoadDocCopy = true;
    }
    if (id == 'inputFileDocCopyFront') {
      this.isFileLoadDocCopyFront = true;
    }
    if (id == 'inputFileDocCopyReverse') {
      this.isFileLoadDocCopyReverse = true;
    }
  }


  /**
   * Description: Método que abre la ventana de carga de archivos adjuntos
   * Autor: Steven Sterling
   * @param N/A
   * @return N/A
   */
  loadHiddenFile(id: string) {
    $("#" + id).click();
  }
  /**
   * Description: Método que valida que existan los archivos adjuntos
   * Autor: Steven Sterling 
   * @param N/A
   * @return N/A
   */
  validateAttachedFiles() {
    var isValidFileLoad = false;
    var fileDocCopy = $("#inputFileDocCopy")[0].files;
    var fileDocCopyFront = $("#inputFileDocCopyFront")[0].files;
    var fileDocCopyReverse = $("#inputFileDocCopyReverse")[0].files;
    if (fileDocCopy.length != 0 || (fileDocCopyFront.length != 0 && fileDocCopyReverse.length != 0)) {
      isValidFileLoad = true;
    }
    return isValidFileLoad;
  }

  /**
   * Description: Método que realiza el cambio de chip
   * Autor: Steven Sterling 
   * @param N/A
   * @return N/A
   */
  changeChip() {
    this.getSemillaAesParam()
    /**
     * @ModifiedBy Julian Ciro Barrera
     * Se ajusta la manera de hacer las validaciónes para poder mostrar mas detalles en las modales según tipo de validación
     */
    if (this.changeChipForm.get('inputLines').value && this.changeChipForm.get('inputICC').value && this.isICCValid &&
      (!this.changeChipForm.get('checkAuto').value || !this.changeChipForm.get('checkTerms').value) && this.validateAttachedFiles()) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('CHANGE_CHIP_MODAL_CONTENT_AUT_TERMS');
      this.isShowModal = true;
      return;
    } else if (!this.changeChipForm.get('inputLines').value || !this.changeChipForm.get('inputICC').value
      || !this.validateAttachedFiles()) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      return;
    }
    if (!this.isICCValid) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_LABEL_MODAL_VALIDATION_ICC_ERROR');
      this.isShowModal = true;
      this.isShowSecondBtn = false;
      return false;
    }


    var fileList = [];
    if (this.fileLoadPortFormData != null) {
      fileList.push({ "name": $('#inputFilePortForm').prop('files')[0].name, "attached": this.fileLoadPortFormData.split(',')[1] });
    }
    if (this.fileLoadDocCopyData != null) {
      fileList.push({ "name": $('#inputFileDocCopy').prop('files')[0].name, "attached": this.fileLoadDocCopyData.split(',')[1] });
    }
    if (this.fileLoadDocCopyFrontData != null) {
      fileList.push({ "name": $('#inputFileDocCopyFront').prop('files')[0].name, "attached": this.fileLoadDocCopyFrontData.split(',')[1] });
    }
    if (this.fileLoadDocCopyReverseData != null) {
      fileList.push({ "name": $('#inputFileDocCopyReverse').prop('files')[0].name, "attached": this.fileLoadDocCopyReverseData.split(',')[1] });
    }

    const userData = JSON.parse(localStorage.getItem("userData"));
    let jsonData = {
      "identification": userData.documentId,
      "msisdn": this.changeChipForm.get('inputLines').value,
      "customerAccountId": userData.customerAccountId,
      "icc": this.changeChipForm.get('inputICC').value,
      "authorize": constants.YES,
      "acceptTerms": constants.YES,
      "email": userData.email,
      "attached": fileList
    }

    let codificador = new CodificadorJWT();
    const jwt = codificador.generarJSON(jsonData, this.valueAes);
    const body = { args: jwt };

    //procesar envio request
    this.isBtnDisabled = true;
    this.changeChipService.sendChangeChipRequest(JSON.stringify(body)).subscribe((valData => {
      this.isBtnDisabled = false;

      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('CHANGE_NUMBER_LABEL_ERROR_REQUEST');
        this.isShowModal = true;
        return false;
      }

      //habilitar botones
      this.isBtnDisabled = false;
      this.isModalReload = true;
      //Parametros a mostrar en la modal
      this.modalTitle = this.LANG.getLangText('CHANGE_CHIP_MODAL_TITTLE_OK');
      this.modalContent = this.LANG.getLangText('CHANGE_CHIP_MODAL_DESC_OK');
      this.isChangeChipBtn = true;
      this.isShowModal = true;

    }),
      (err) => {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR') + err.code;
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        this.isBtnDisabled = false;
      });

  }


  /**
   * Description: Método que esconde la ventana modal
   * Autor: Steven Sterling 
   * @param N/A
   * @return N/A
   */
  hideModal() {
    this.isShowModal = false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    }
  }

  /**
   * Description: Método que valida si el ICC es permitido
   * Autor: Diego Diaz
   * @param  N/A
   * @return confirmación de la validación
   */
  validateICCID() {
    this.isICCValid = false;
    this.isLoading = true;
    this.isLoadingICC = true;
    this.changeChipService.validateICC(this.changeChipForm.get('inputICC').value).subscribe((valData => {
      this.isLoading = false;
      this.isLoadingICC = false;
      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE || valData["obj"].valid != true) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('PORTABILITY_LABEL_MODAL_VALIDATION_ICC_ERROR');
        this.isShowModal = true;
        this.isShowSecondBtn = false;
        return false;
      }

      this.isICCValid = true;

    }),
      (err) => {
        this.isLoadingICC = false;
        this.isLoading = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR') + err.code;
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        this.isShowSecondBtn = false;
      });

  }

  /**
 * Description: Método que carga el archivo seleccionado
 * Autor: Diego Diaz
 * @param inputValue campo tipo file
 * @param id identificador
 * @return N/A
 */
  getBase64(inputValue, id) {
    var file: File = inputValue.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    var _self = this;
    reader.onload = function () {
      if (id == 'inputFilePortForm') {
        _self.fileLoadPortFormData = reader.result;
      }
      if (id == 'inputFileDocCopy') {
        _self.fileLoadDocCopyData = reader.result;
        $("#inputFileDocCopyFrontFace").val("");
        $("#inputFileDocCopyFront").val("");
        $("#inputFileDocCopyReverseFace").val("");
        $("#inputFileDocCopyReverse").val("");
        _self.fileLoadDocCopyFrontData = null;
        _self.fileLoadDocCopyReverseData = null;
      }
      if (id == 'inputFileDocCopyFront') {
        _self.fileLoadDocCopyFrontData = reader.result;
        $("#inputFileDocCopyFace").val("");
        $("#inputFileDocCopy").val("");
        _self.fileLoadDocCopyData = null;
      }
      if (id == 'inputFileDocCopyReverse') {
        _self.fileLoadDocCopyReverseData = reader.result;
        $("#inputFileDocCopyFace").val("");
        $("#inputFileDocCopy").val("");
        _self.fileLoadDocCopyData = null;
      }
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  getSemillaAesParam(){
		this.privacyService.getGroupParameters("WS_SEMILLA").subscribe(((dataResponse:any) => {
      this.valueAes = dataResponse.obj[0].value
		}))
	}
}
